import { ReactComponent as IlustracaoAtendimento } from "../../assets/img/atendimento.svg"
import { ReactComponent as Config } from "../../assets/icons/config.svg"
import { ReactComponent as Setting } from "../../assets/icons/setting.svg"
import { ReactComponent as BarGraph } from "../../assets/icons/bar-graph.svg"
import { ReactComponent as Question } from "../../assets/icons/question.svg"
import { ReactComponent as Company } from "../../assets/icons/company.svg"
import { ReactComponent as FolderPlus } from "../../assets/icons/folder-plus.svg"
import { ReactComponent as Help } from "../../assets/icons/help.svg"
import { ReactComponent as NoPhoto } from "../../assets/icons/nopic.svg"
import { ReactComponent as AddNew } from "../../assets/icons/add-new.svg"
import { ReactComponent as DragBalls } from "../../assets/icons/drag-balls.svg"
import { ReactComponent as Trash } from "../../assets/icons/trash.svg"
import { ReactComponent as ButtonClose } from "../../assets/icons/button-close.svg"
import { ReactComponent as IconDanger } from "../../assets/icons/icon-danger.svg"
import { ReactComponent as IconSuccess } from "../../assets/icons/icon-success.svg"
import { ReactComponent as IconFilter } from "../../assets/icons/icon-filter.svg"
import { ReactComponent as ManejeIconLoading } from "../../assets/icons/maneje-loading.svg"
import { ReactComponent as ManejeIconOpacity } from "../../assets/icons/maneje-icon-opacity.svg"
import { ReactComponent as DBIcon } from "../../assets/icons/db-icon.svg"
import { ReactComponent as ArrowBack } from "../../assets/icons/arrow-back.svg"

// Novos
import { ReactComponent as DashboardIcon } from "../../assets/icons/dashboard.svg"
import { ReactComponent as UserIcon } from "../../assets/icons/user.svg"
import { ReactComponent as CloseGrayIcon } from "../../assets/icons/icon-close-gray.svg"
import { ReactComponent as CloseGreenIcon } from "../../assets/icons/icon-close-green.svg"
import { ReactComponent as UploadIcon } from "../../assets/icons/icon-upload.svg"
import { ReactComponent as MapIcon } from "../../assets/icons/map.svg"
import { ReactComponent as NoDataGraph } from "../../assets/icons/noGraph.svg"
import { ReactComponent as ChatIcon } from "../../assets/icons/chat/icon.svg"
import { ReactComponent as AlertIcon } from "../../assets/icons/alert.svg"
import { ReactComponent as HistoryIcon } from "../../assets/icons/history.svg"
import { ReactComponent as ESMIcon } from "../../assets/icons/icon-esm.svg"
import { ReactComponent as ArrowNext } from "../../assets/icons/arrow-next.svg"
import { ReactComponent as QualityIcon } from "../../assets/icons/icon-quality.svg"
import { ReactComponent as ProjectIcon } from "../../assets/icons/project-icon.svg"
import { ReactComponent as AddFile } from "../../assets/icons/chat/file-add.svg"
import { ReactComponent as MicIcon } from "../../assets/icons/chat/mic.svg"
import { ReactComponent as ArrowSendIcon } from "../../assets/icons/chat/arrow-send.svg"


const JourneyIcon = () => {
  return <i className="fi fi-sr-vector-circle"/>
}

const ReportsIcon = () => {
  return <i className="fi fi-sr-form"/>
}

const FarmerIcon = () => {
  return <i className="fi fi-ss-address-book"/>
}

const AssistanceIcon = () => {
  return <i className="fi-sr-comment-alt"/>
}


const CalendarIcon = () => {
  return <i className="fi fi-sr-calendar"/>
}

const FormIcon = () => {
  return <i className="fi fi-sr-form"/>
}

const RegisterContentIcon = () => {
  return <i className="fi fi-sr-browser"/>
}

const TermsIcon = () => {
  return <i className="fi fi-sr-user-robot"/>
}

export {
  IlustracaoAtendimento,
  Config,
  BarGraph,
  Company,
  Question,
  FolderPlus,
  Help,
  Setting,
  NoPhoto,
  AddNew,
  DragBalls,
  Trash,
  ButtonClose,
  IconDanger,
  IconSuccess,
  IconFilter,
  ManejeIconLoading,
  ManejeIconOpacity,
  DBIcon,
  ArrowBack,
  DashboardIcon,
  UserIcon,
  CloseGrayIcon,
  CloseGreenIcon,
  UploadIcon,
  MapIcon,
  NoDataGraph,
  ChatIcon,
  ReportsIcon,
  AlertIcon,
  HistoryIcon,
  ESMIcon,
  ArrowNext,
  QualityIcon,
  ProjectIcon,
  JourneyIcon,
  AssistanceIcon,
  CalendarIcon,
  FormIcon,
  RegisterContentIcon,
  FarmerIcon,
  TermsIcon,
  AddFile,
  MicIcon,
  ArrowSendIcon
}
